<div class="bell-schedules-list-filters-content">
  <mat-slide-toggle
    unique-id
    [color]="'primary'"
    class="filter-item"
    (toggleChange)="filters.inactive = !filters.inactive; filtersUpdated.emit(filters)"
  >
    Show Inactive
  </mat-slide-toggle>
</div>